/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Policy_DescInputs */

const en_mk_team_policy_desc = /** @type {(inputs: Mk_Team_Policy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep only uses paths the AI providers allow. Your subscription login stays in the official agent on your computer, not on our servers.`)
};

const id_mk_team_policy_desc = /** @type {(inputs: Mk_Team_Policy_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep hanya memakai jalur yang diizinkan penyedia AI. Login langgananmu tetap di agent resmi di komputermu, bukan di server kami.`)
};

/**
* | output |
* | --- |
* | "Bystep only uses paths the AI providers allow. Your subscription login stays in the official agent on your computer, not on our servers." |
*
* @param {Mk_Team_Policy_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_policy_desc = /** @type {((inputs?: Mk_Team_Policy_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Policy_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_policy_desc(inputs)
	return en_mk_team_policy_desc(inputs)
});